// import React, { useEffect, useState } from "react";
// import { Outlet, NavLink, useNavigate, useParams } from "react-router-dom";
// import {
//   AppBar,
//   Box,
//   CssBaseline,
//   Drawer,
//   IconButton,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Toolbar,
//   Typography,
//   Button,
// } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import LogoutIcon from "@mui/icons-material/Logout";

// import {
//   ListOrdered,
//   ShoppingCart,
//   CreditCard,
//   UserCircle,
//   Package,
//   FileText,
//   Receipt,
//   Undo2,
//   UserPlus,
//   Layers,
//   User,
// } from "lucide-react";
// import axios from "axios";

// // ✅ Inter font (same as Admin)
// import "@fontsource/inter/400.css";
// import "@fontsource/inter/500.css";
// import { Api } from "../Api/Api";

// const drawerWidth = 260;

// export default function WorkerLayout() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [workerName, setWorkerName] = useState("Worker");
//   const [mobileOpen, setMobileOpen] = useState(false);

//   const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
//   const workerId = currentUser?.id;
//   const API_WORKERS = `${Api}worker/get_all.php`;

//   console.log('localStorage currentUser raw:', localStorage.getItem('currentUser'));
// console.log('parsed:', JSON.parse(localStorage.getItem('currentUser') || '{}'));

//   // Fetch worker name
//   const fetchWorkerName = async () => {
//     try {
//       const res = await axios.get(API_WORKERS);
//       const workers = res.data;
//       const worker = workers.find((w) => w.id === id);
//       if (worker) setWorkerName(worker.username);
//       console.log(workerName)
//     } catch (err) {
//       console.error("Error fetching worker name:", err);
//     }
//   };

//   useEffect(() => {
//     fetchWorkerName();
//   }, [id]);

//   useEffect(() => {
//     if (currentUser.type !== "worker") navigate("/");
//   }, [navigate, currentUser]);

//   const handleLogout = () => {
//     localStorage.removeItem("currentUser");
//     localStorage.removeItem("token");
//     navigate("/", { replace: true });
//   };

//   const sidebarItems = [
//     {
//       title: "Dashboard",
//       href: `/worker/quantity/${workerId}`,
//       icon: <ListOrdered size={18} />, // Ordered list for dashboard
//     },
//     {
//       title: "Wholesale Billing",
//       href: `/worker/wholesale/${workerId}`,
//       icon: <CreditCard size={18} />, // Billing/credit
//     },
//     {
//       title: "Worker Bills",
//       href: `/worker/workerbills/${workerId}`,
//       icon: <FileText size={18} />, // Single bill
//     },
//     {
//       title: "All Worker Bills",
//       href: `/worker/all-workers-bills/${workerId}`,
//       icon: <Receipt size={18} />, // Multiple bills
//     },
//     {
//       title: "Worker Credit Details",
//       href: `/worker/workers-credit-details/${workerId}`,
//       icon: <Layers size={18} />, // Credit/finance
//     },
//     {
//       title: "Worker Stock Return",
//       href: `/worker/workerstockreturn/${workerId}`,
//       icon: <Undo2 size={18} />, // Return/undo
//     },
//     {
//       title: "Product Management",
//       href: "/worker/wholesale",
//       icon: <Package size={18} />,
//     },
//     {
//       title: "Create Worker",
//       href: `/worker/create-id/${workerId}`,
//       icon: <UserPlus size={18} />, // Add new worker
//     },
//     {
//       title: "Retail Billing",
//       href: `/worker/billing/${workerId}`,
//       icon: <ShoppingCart size={18} />, // Retail billing
//     },
//     {
//       title: "Retail Customer Bills",
//       href: `/worker/retail/${workerId}`,
//       icon: <FileText size={18} />, // Customer bills
//     },
//     {
//       title: "Retail Credit Details",
//       href: `/worker/credit/${workerId}`,
//       icon: <CreditCard size={18} />, // Credit info
//     },
//     {
//       title: "Customer Details",
//       href: "/worker/worker-customer-details",
//       icon: <UserCircle size={18} />, // Customers
//     },
//     {
//       title: "Product Details",
//       href: "/worker/product-details",
//       icon: <Package size={18} />, // Product stock
//     },

//     {
//       title: "Stock Credit",
//       href: "/worker/stock-credit",
//       icon: <Layers size={18} />, // Stock/credit info
//     },
//   ];

//   const drawer = (
//     <Box
//       sx={{
//         height: "100%",
//         display: "flex",
//         flexDirection: "column",
//         bgcolor: "#0F3E2C",
//         color: "#FFFFFF",
//         fontFamily: "Inter, sans-serif",
//       }}
//     >
//       {/* Sidebar header */}
//       <Toolbar sx={{ borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
//         <Typography
//           variant="h6"
//           noWrap
//           sx={{
//             fontWeight: 600,
//             color: "#FFD700",
//             fontFamily: "Inter, sans-serif",
//           }}
//         >
//           Sri Murugan Ayurvedha
//         </Typography>
//       </Toolbar>

//       {/* Sidebar nav with scrollable list */}

//       <Box
//   sx={{
//     flex: 1,
//     p: 1,
//     overflowY: "auto",
//     "&::-webkit-scrollbar": { width: 0 }, // hide scrollbar for Chrome, Safari
//     scrollbarWidth: "none", // hide scrollbar for Firefox
//     msOverflowStyle: "none", // hide scrollbar for IE 10+
//   }}
// >

//         <List sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
//           {sidebarItems.map((item) => (
//             <ListItem key={item.href} disablePadding>
//               <ListItemButton
//                 component={NavLink}
//                 to={item.href}
//                 onClick={() => setMobileOpen(false)}
//                 disableRipple
//                 sx={{
//                   borderRadius: 1.2,
//                   py: 1,
//                   px: 1.6,
//                   fontFamily: "Inter, sans-serif",
//                   fontSize: "0.95rem",
//                   fontWeight: 500,
//                   lineHeight: 1.5,
//                   color: "rgba(255,255,255,0.85)",
//                   transition: "all 0.25s ease",
//                   "&.active": {
//                     bgcolor: "#2C5F49",
//                     color: "#fff",
//                     fontWeight: 600,
//                     "& .MuiListItemIcon-root": { color: "#fff" },
//                   },
//                   "&:hover": {
//                     bgcolor: "#1B4D38",
//                     color: "#fff",
//                   },
//                 }}
//               >
//                 <ListItemIcon sx={{ color: "inherit", minWidth: 34 }}>
//                   {item.icon}
//                 </ListItemIcon>
//                 <ListItemText
//                   primary={item.title}
//                   primaryTypographyProps={{
//                     fontFamily: "Inter, sans-serif",
//                     fontSize: "0.95rem",
//                     fontWeight: 500,
//                   }}
//                 />
//               </ListItemButton>
//             </ListItem>
//           ))}
//         </List>
//       </Box>
//     </Box>
//   );
//   return (
//     <Box sx={{ display: "flex", fontFamily: "Inter, sans-serif" }}>
//       <CssBaseline />

//       {/* Top AppBar */}
//       <AppBar
//         position="fixed"
//         sx={{
//           width: { sm: `calc(100% - ${drawerWidth}px)` },
//           ml: { sm: `${drawerWidth}px` },
//           bgcolor: "rgba(15, 62, 42, 1)",
//           color: "white",
//           fontFamily: "Inter, sans-serif",
//         }}
//       >
//         <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
//           {/* Mobile menu button */}
//           <IconButton
//             color="inherit"
//             edge="start"
//             onClick={() => setSidebarOpen(!sidebarOpen)}
//             sx={{ mr: 2, display: { sm: "none" } }}
//           >
//             <MenuIcon />
//           </IconButton>

//           {/* Right side */}
//           <Box
//             sx={{ display: "flex", alignItems: "center", gap: 2, ml: "auto" }}
//           >
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1,
//                 px: 2,
//                 py: 0.5,
//                 bgcolor: "rgba(255,255,255,0.1)",
//                 borderRadius: 2,
//                 fontFamily: "Inter, sans-serif",
//               }}
//             >
//               <User size={16} />
//               <Typography variant="body2" sx={{ fontWeight: 500 }}>
//                 {workerName}
//               </Typography>
//             </Box>
//             <Button
//               onClick={handleLogout}
//               variant="contained"
//               size="small"
//               startIcon={<LogoutIcon />}
//               sx={{
//                 textTransform: "none",
//                 borderRadius: 2,
//                 fontFamily: "Inter, sans-serif",
//                 fontWeight: 500,
//                 bgcolor: "#E63946",
//                 "&:hover": { bgcolor: "#c72c38" },
//               }}
//             >
//               Logout
//             </Button>
//           </Box>
//         </Toolbar>
//       </AppBar>

//       {/* Sidebar */}
//       <Box
//         component="nav"
//         sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
//       >
//         {/* Mobile Drawer */}
//         <Drawer
//           variant="temporary"
//           open={sidebarOpen}
//           onClose={() => setSidebarOpen(false)}
//           ModalProps={{ keepMounted: true }}
//           sx={{
//             display: { xs: "block", sm: "none" },
//             "& .MuiDrawer-paper": { width: drawerWidth, bgcolor: "#0F3E2C" },
//           }}
//         >
//           {drawer}
//         </Drawer>

//         {/* Desktop Drawer */}
//         <Drawer
//           variant="permanent"
//           sx={{
//             display: { xs: "none", sm: "block" },
//             "& .MuiDrawer-paper": {
//               width: drawerWidth,
//               boxSizing: "border-box",
//               bgcolor: "#0F3E2C",
//               color: "white",
//               overflow: "hidden",
//             },
//           }}
//           open
//         >
//           {drawer}
//         </Drawer>
//       </Box>

//       {/* Main Content */}

//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           p: { xs: 1, sm: 3 },
//           width: { xs: "100%", sm: `calc(100% - ${drawerWidth}px)` },
//           mt: { xs: 7, sm: 8 }, // keep spacing for AppBar
//           bgcolor: "#FAFAF5",
//           height: "calc(100vh - 64px)", // AppBar height (64px default)
//           overflowY: "auto", // 👈 only this scrolls
//         }}
//       >
//         <Outlet />
//       </Box>
//     </Box>
//   );
// }

// import React, { useEffect, useState } from "react";
// import { Outlet, NavLink, useNavigate, useParams } from "react-router-dom";
// import {
//   AppBar,
//   Box,
//   CssBaseline,
//   Drawer,
//   IconButton,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Toolbar,
//   Typography,
//   Button,
// } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import LogoutIcon from "@mui/icons-material/Logout";

// import {
//   ListOrdered,
//   ShoppingCart,
//   CreditCard,
//   UserCircle,
//   Package,
//   FileText,
//   Receipt,
//   Undo2,
//   UserPlus,
//   Layers,
//   User,
// } from "lucide-react";
// import axios from "axios";

// import "@fontsource/inter/400.css";
// import "@fontsource/inter/500.css";
// import { Api } from "../Api/Api";

// const drawerWidth = 260;

// export default function WorkerLayout() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [sidebarOpen, setSidebarOpen] = useState(false);

//   // parse currentUser once
//   const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
//   const workerId = currentUser?.id;
//   const API_WORKERS = `${Api}worker/get_all.php`;

//   // initialize workerName from localStorage (shows immediately)
//   const [workerName, setWorkerName] = useState(
//     currentUser?.username || "Worker"
//   );

//   // Debug logs (will show the updated workerName because of useEffect below)
//   console.log(
//     "localStorage currentUser raw:",
//     localStorage.getItem("currentUser")
//   );
//   console.log("parsed:", currentUser);

//   // Fetch worker name from API only if needed (fallback)
//   const fetchWorkerName = async () => {
//     try {
//       if (currentUser?.id && currentUser?.id === id && currentUser?.username) {
//         setWorkerName(currentUser.username);
//         return;
//       }
//       const res = await axios.get(API_WORKERS);
//       const workers = res.data;
//       const worker = workers.find((w) => w.id === id || w.id === workerId);
//       if (worker && worker.username) {
//         setWorkerName(worker.username);
//       }
//     } catch (err) {
//       console.error("Error fetching worker name:", err);
//     }
//   };

//   useEffect(() => {
//     fetchWorkerName();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [id, workerId]);

//   useEffect(() => {
//     if (currentUser?.type !== "worker") navigate("/");
//   }, [navigate, currentUser]);

//   useEffect(() => {
//     console.log("workerName updated:", workerName);
//   }, [workerName]);

//   const handleLogout = () => {
//     localStorage.removeItem("currentUser");
//     localStorage.removeItem("token");
//     navigate("/", { replace: true });
//   };

//   const sidebarItems = [
//     {
//       title: "Dashboard",
//       href: `/worker/quantity/${workerId}`,
//       icon: <ListOrdered size={18} />,
//     },
//     {
//       title: "Wholesale Billing",
//       href: `/worker/wholesale/${workerId}`,
//       icon: <CreditCard size={18} />,
//     },
//     {
//       title: "Worker Bills",
//       href: `/worker/workerbills/${workerId}`,
//       icon: <FileText size={18} />,
//     },
//     {
//       title: "All Worker Bills",
//       href: `/worker/all-workers-bills/${workerId}`,
//       icon: <Receipt size={18} />,
//     },
//     {
//       title: "Worker Credit Details",
//       href: `/worker/workers-credit-details/${workerId}`,
//       icon: <Layers size={18} />,
//     },
//     {
//       title: "Worker Stock Return",
//       href: `/worker/workerstockreturn/${workerId}`,
//       icon: <Undo2 size={18} />,
//     },
//     {
//       title: "Product Management",
//       href: "/worker/wholesale",
//       icon: <Package size={18} />,
//     },
//     {
//       title: "Create Worker",
//       href: `/worker/create-id/${workerId}`,
//       icon: <UserPlus size={18} />,
//     },
//     {
//       title: "Retail Billing",
//       href: `/worker/billing/${workerId}`,
//       icon: <ShoppingCart size={18} />,
//     },
//     {
//       title: "Retail Customer Bills",
//       href: `/worker/retail/${workerId}`,
//       icon: <FileText size={18} />,
//     },
//     {
//       title: "Retail Credit Details",
//       href: `/worker/credit/${workerId}`,
//       icon: <CreditCard size={18} />,
//     },
//     {
//       title: "Customer Details",
//       href: "/worker/worker-customer-details",
//       icon: <UserCircle size={18} />,
//     },
//     {
//       title: "Product Details",
//       href: "/worker/product-details",
//       icon: <Package size={18} />,
//     },
//     {
//       title: "Stock Credit",
//       href: "/worker/stock-credit",
//       icon: <Layers size={18} />,
//     },
//   ];

//   const drawer = (
//     <Box
//       sx={{
//         height: "100%",
//         display: "flex",
//         flexDirection: "column",
//         bgcolor: "#0F3E2C",
//         color: "#FFFFFF",
//         fontFamily: "Inter, sans-serif",
//       }}
//     >
//       <Toolbar sx={{ borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
//         <Typography
//           variant="h6"
//           noWrap
//           sx={{
//             fontWeight: 600,
//             color: "#FFD700",
//             fontFamily: "Inter, sans-serif",
//           }}
//         >
//           Sri Murugan Ayurvedha
//         </Typography>
//       </Toolbar>

//       <Box
//         sx={{
//           flex: 1,
//           p: 1,
//           overflowY: "auto",
//           "&::-webkit-scrollbar": { width: 0 },
//           scrollbarWidth: "none",
//           msOverflowStyle: "none",
//         }}
//       >
//         <List sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
//           {sidebarItems.map((item) => (
//             <ListItem key={item.href} disablePadding>
//               <ListItemButton
//                 // remove component={NavLink} and let navigate handle routing
//                 onClick={() => {
//                   setSidebarOpen(false); // close temporary drawer on mobile
//                   navigate(item.href); // navigate to route
//                 }}
//                 disableRipple
//                 sx={{
//                   borderRadius: 1.2,
//                   py: 1,
//                   px: 1.6,
//                   fontFamily: "Inter, sans-serif",
//                   fontSize: "0.95rem",
//                   fontWeight: 500,
//                   lineHeight: 1.5,
//                   color: "rgba(255,255,255,0.85)",
//                   transition: "all 0.25s ease",
//                   "&.active": {
//                     bgcolor: "#2C5F49",
//                     color: "#fff",
//                     fontWeight: 600,
//                     "& .MuiListItemIcon-root": { color: "#fff" },
//                   },
//                   "&:hover": {
//                     bgcolor: "#1B4D38",
//                     color: "#fff",
//                   },
//                 }}
//               >
//                 <ListItemIcon sx={{ color: "inherit", minWidth: 34 }}>
//                   {item.icon}
//                 </ListItemIcon>
//                 <ListItemText
//                   primary={item.title}
//                   primaryTypographyProps={{
//                     fontFamily: "Inter, sans-serif",
//                     fontSize: "0.95rem",
//                     fontWeight: 500,
//                   }}
//                 />
//               </ListItemButton>
//             </ListItem>
//           ))}
//         </List>
//       </Box>
//     </Box>
//   );

//   return (
//     <Box sx={{ display: "flex", fontFamily: "Inter, sans-serif" }}>
//       <CssBaseline />

//       <AppBar
//         position="fixed"
//         sx={{
//           width: { sm: `calc(100% - ${drawerWidth}px)` },
//           ml: { sm: `${drawerWidth}px` },
//           bgcolor: "rgba(15, 62, 42, 1)",
//           color: "white",
//           fontFamily: "Inter, sans-serif",
//         }}
//       >
//         <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
//           <IconButton
//             color="inherit"
//             edge="start"
//             onClick={() => setSidebarOpen(!sidebarOpen)}
//             sx={{ mr: 2, display: { sm: "none" } }}
//           >
//             <MenuIcon />
//           </IconButton>

//           <Box
//             sx={{ display: "flex", alignItems: "center", gap: 2, ml: "auto" }}
//           >
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1,
//                 px: 2,
//                 py: 0.5,
//                 bgcolor: "rgba(255,255,255,0.1)",
//                 borderRadius: 2,
//                 fontFamily: "Inter, sans-serif",
//               }}
//             >
//               <User size={16} />
//               <Typography variant="body2" sx={{ fontWeight: 500 }}>
//                 {workerName}
//               </Typography>
//             </Box>
//             <Button
//               onClick={handleLogout}
//               variant="contained"
//               size="small"
//               startIcon={<LogoutIcon />}
//               sx={{
//                 textTransform: "none",
//                 borderRadius: 2,
//                 fontFamily: "Inter, sans-serif",
//                 fontWeight: 500,
//                 bgcolor: "#E63946",
//                 "&:hover": { bgcolor: "#c72c38" },
//               }}
//             >
//               Logout
//             </Button>
//           </Box>
//         </Toolbar>
//       </AppBar>

//       <Box
//         component="nav"
//         sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
//       >
//         <Drawer
//           variant="temporary"
//           open={sidebarOpen}
//           onClose={() => setSidebarOpen(false)}
//           ModalProps={{ keepMounted: true }}
//           sx={{
//             display: { xs: "block", sm: "none" },
//             "& .MuiDrawer-paper": { width: drawerWidth, bgcolor: "#0F3E2C" },
//           }}
//         >
//           {drawer}
//         </Drawer>

//         <Drawer
//           variant="permanent"
//           sx={{
//             display: { xs: "none", sm: "block" },
//             "& .MuiDrawer-paper": {
//               width: drawerWidth,
//               boxSizing: "border-box",
//               bgcolor: "#0F3E2C",
//               color: "white",
//               overflow: "hidden",
//             },
//           }}
//           open
//         >
//           {drawer}
//         </Drawer>
//       </Box>

//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           p: { xs: 1, sm: 3 },
//           width: { xs: "100%", sm: `calc(100% - ${drawerWidth}px)` },
//           mt: { xs: 7, sm: 8 },
//           bgcolor: "#FAFAF5",
//           height: "calc(100vh - 64px)",
//           overflowY: "auto",
//         }}
//       >
//         <Outlet />
//       </Box>
//     </Box>
//   );
// }



import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams, useLocation } from "react-router-dom";
import {
  AppBar,
  Box,
  CssBaseline,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import {
  ListOrdered,
  ShoppingCart,
  CreditCard,
  UserCircle,
  Package,
  FileText,
  Receipt,
  Undo2,
  UserPlus,
  Layers,
  User,
} from "lucide-react";
import axios from "axios";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import { Api } from "../Api/Api";

const drawerWidth = 260;

export default function WorkerLayout() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [workerName, setWorkerName] = useState("Worker");

  // Main unified effect similar to admin layout
  useEffect(() => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

    // Security: only allow workers
    if (currentUser.type !== "worker") {
      navigate("/");
      return;
    }

    // Priority 1: If navigation provided a selectedWorker in state
    if (location?.state && location.state.selectedWorker) {
      setWorkerName(location.state.selectedWorker);
      return;
    }

    // Priority 2: If username exists locally
    if (currentUser.username) {
      setWorkerName(currentUser.username);
      return;
    }

    // Priority 3: Fallback - fetch worker info from API
    const fetchWorkerName = async () => {
      try {
        const res = await axios.get(`${Api}worker/get_all.php`);
        const workers = res.data || [];
        const worker = workers.find(
          (w) => w.id === currentUser.id || w.id === id
        );
        if (worker?.username) {
          setWorkerName(worker.username);
        } else {
          setWorkerName("Worker");
        }
      } catch (err) {
        console.error("Error fetching worker name:", err);
        setWorkerName("Worker");
      }
    };

    fetchWorkerName();
  }, [location, navigate, id]);

  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const workerId = currentUser?.id;

  const handleLogout = () => {
    localStorage.removeItem("currentUser");
    localStorage.removeItem("token");
    navigate("/", { replace: true });
  };

  const sidebarItems = [
    {
      title: "Dashboard",
      href: `/worker/quantity/${workerId}`,
      icon: <ListOrdered size={18} />,
    },
    {
      title: "Wholesale Billing",
      href: `/worker/wholesale/${workerId}`,
      icon: <CreditCard size={18} />,
    },
    {
      title: "Worker Bills",
      href: `/worker/workerbills/${workerId}`,
      icon: <FileText size={18} />,
    },
    {
      title: "All Worker Bills",
      href: `/worker/all-workers-bills/${workerId}`,
      icon: <Receipt size={18} />,
    },
    {
      title: "Worker Credit Details",
      href: `/worker/workers-credit-details/${workerId}`,
      icon: <Layers size={18} />,
    },
    {
      title: "Worker Stock Return",
      href: `/worker/workerstockreturn/${workerId}`,
      icon: <Undo2 size={18} />,
    },
    {
      title: "Product Management",
      href: "/worker/wholesale",
      icon: <Package size={18} />,
    },
    {
      title: "Create Worker",
      href: `/worker/create-id/${workerId}`,
      icon: <UserPlus size={18} />,
    },
    {
      title: "Retail Billing",
      href: `/worker/billing/${workerId}`,
      icon: <ShoppingCart size={18} />,
    },
    {
      title: "Retail Customer Bills",
      href: `/worker/retail/${workerId}`,
      icon: <FileText size={18} />,
    },
    {
      title: "Retail Credit Details",
      href: `/worker/credit/${workerId}`,
      icon: <CreditCard size={18} />,
    },
    {
      title: "Customer Details",
      href: "/worker/worker-customer-details",
      icon: <UserCircle size={18} />,
    },
    {
      title: "Product Details",
      href: "/worker/product-details",
      icon: <Package size={18} />,
    },
    {
      title: "Stock Credit",
      href: "/worker/stock-credit",
      icon: <Layers size={18} />,
    },
  ];

  const drawer = (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        bgcolor: "#0F3E2C",
        color: "#FFFFFF",
        fontFamily: "Inter, sans-serif",
      }}
    >
      <Toolbar sx={{ borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
        <Typography
          variant="h6"
          noWrap
          sx={{
            fontWeight: 600,
            color: "#FFD700",
            fontFamily: "Inter, sans-serif",
          }}
        >
          Sri Murugan Ayurvedha
        </Typography>
      </Toolbar>

      <Box
        sx={{
          flex: 1,
          p: 1,
          overflowY: "auto",
          "&::-webkit-scrollbar": { width: 0 },
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <List sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          {sidebarItems.map((item) => (
            <ListItem key={item.href} disablePadding>
              <ListItemButton
                onClick={() => {
                  setSidebarOpen(false);
                  navigate(item.href);
                }}
                disableRipple
                sx={{
                  borderRadius: 1.2,
                  py: 1,
                  px: 1.6,
                  fontFamily: "Inter, sans-serif",
                  fontSize: "0.95rem",
                  fontWeight: 500,
                  color: "rgba(255,255,255,0.85)",
                  transition: "all 0.25s ease",
                  "&:hover": {
                    bgcolor: "#1B4D38",
                    color: "#fff",
                  },
                }}
              >
                <ListItemIcon sx={{ color: "inherit", minWidth: 34 }}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={item.title}
                  primaryTypographyProps={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "0.95rem",
                    fontWeight: 500,
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );

  return (
    <Box sx={{ display: "flex", fontFamily: "Inter, sans-serif" }}>
      <CssBaseline />

      {/* Top AppBar */}
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          bgcolor: "rgba(15, 62, 42, 1)",
          color: "white",
          fontFamily: "Inter, sans-serif",
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <IconButton
            color="inherit"
            edge="start"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          <Box
            sx={{ display: "flex", alignItems: "center", gap: 2, ml: "auto" }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 2,
                py: 0.5,
                bgcolor: "rgba(255,255,255,0.1)",
                borderRadius: 2,
              }}
            >
              <User size={16} />
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {workerName}
              </Typography>
            </Box>
            <Button
              onClick={handleLogout}
              variant="contained"
              size="small"
              startIcon={<LogoutIcon />}
              sx={{
                textTransform: "none",
                borderRadius: 2,
                fontWeight: 500,
                bgcolor: "#E63946",
                "&:hover": { bgcolor: "#c72c38" },
              }}
            >
              Logout
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Side Drawer */}
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
      >
        <Drawer
          variant="temporary"
          open={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": { width: drawerWidth, bgcolor: "#0F3E2C" },
          }}
        >
          {drawer}
        </Drawer>

        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              bgcolor: "#0F3E2C",
              color: "white",
              boxSizing: "border-box",
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 1, sm: 3 },
          width: { xs: "100%", sm: `calc(100% - ${drawerWidth}px)` },
          mt: { xs: 7, sm: 8 },
          bgcolor: "#FAFAF5",
          height: "calc(100vh - 64px)",
          overflowY: "auto",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
